import { render, staticRenderFns } from "./CardAtendimentos.vue?vue&type=template&id=ce19d7e6&"
import script from "./CardAtendimentos.vue?vue&type=script&lang=js&"
export * from "./CardAtendimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports